import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  completePropertyProfilePageWrapper: {
    backgroundColor: theme.palette.background.primary,
    padding: '20px 32px',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    width: '100%',
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      padding: '16px 20px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '12px 16px',
      gap: '16px',
    },
  },
  basicInfoWrapper: {
    minHeight: '648px',
    width: '100%',
    maxWidth: '100%',
    backgroundColor: theme.palette.background.gray_50,
    padding: '24px 32px',
    border: '1px solid ' + theme.palette.border.secondary,
    borderRadius: '12px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      padding: '20px 24px',
      minHeight: 'auto',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '16px 20px',
    },
  },
  CPP_itemWrapper: {
    width: '100%',
    height: '100%',
    maxHeight: '44px',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '32px',
    margin: '16px 0',
  },
  CPP_fieldLabel: {
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '20px',
    color: theme.palette.text.secondary,
    height: '20px',
    width: '220px',
    minWidth: '150px',
    flexShrink: 0,
    maxWidth: '220px',
  },
  CPP_fieldWrapper: {
    width: '100%',
    height: '100%',
    maxWidth: '512px',
    maxHeight: '44px',
    display: 'flex',
    alignItems: 'center',
  },
  CPP_basicInfoHeader: {
    color: theme.palette.text.primary,
    fontFamily: 'Inter',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '28px',
    marginBottom: '16px',
  },
  CPP_BI_PropertySpecificationSectionWrapper: {
    minHeight: '388px',
    width: '100%',
    padding: '24px 32px',
    border: '1px solid ' + theme.palette.border.secondary,
    backgroundColor: theme.palette.background.gray_50,
    borderRadius: '12px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      padding: '20px 24px',
      minHeight: 'auto',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '16px 20px',
    },
  },
  CPP_BI_PropertySpecificationSectionTitle: {
    color: theme.palette.text.primary,
    fontFamily: 'Inter',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '28px',
  },
  CPP_BI_FinancialInformationSectionWrapper: {
    minHeight: '311px',
    width: '100%',
    padding: '24px 32px',
    border: '1px solid ' + theme.palette.border.secondary,
    backgroundColor: theme.palette.background.gray_50,
    borderRadius: '12px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      padding: '20px 24px',
      minHeight: 'auto',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '16px 20px',
    },
  },
  CPP_BI_FinancialInformationSectionTitle: {
    color: theme.palette.text.primary,
    fontFamily: 'Inter',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '28px',
  },
  CPP_BI_NonGCCbuyersSectionWrapper: {
    minHeight: '68px',
    width: '100%',
    padding: '24px 32px',
    border: '1px solid ' + theme.palette.border.secondary,
    backgroundColor: theme.palette.background.gray_50,
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    gap: '32px',
  },
  CPP_BI_NonGCCbuyersSectionTitle: {
    color: theme.palette.text.primary,
    fontFamily: 'Inter',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '28px',
  },
  CPP_BI_NonGCCbuyersRadioWrapper:{
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  }
}));
